import { Group, Text } from '@mantine/core';

import { MetricHint } from './MetricHint';
import { StatRowProps } from './StatRow';

export function TotalRow({ label, value, hint }: StatRowProps) {
  return (
    <Group justify="space-between">
      <Group gap={4}>
        <Text size="sm" fw={600} c="green">
          {label}
        </Text>
        {hint && <MetricHint hint={hint} />}
      </Group>
      <Text size="sm" fw={600} c="green">
        {value}
      </Text>
    </Group>
  );
}
